<template>
  <v-card class="mx-auto pa-5">
    <v-card-title class="mx-0 px-0">Create New Config</v-card-title>
    <v-row>
      <v-col cols="6"><v-text-field dense outlined label="Username" v-model="item.username"/></v-col>
      <v-col cols="6"><v-text-field dense outlined label="Password" v-model="item.password"/></v-col>
      <v-col cols="12"><v-textarea dense outlined label="Configs" v-model="item.configs"></v-textarea></v-col>
</v-row>
    <v-card-actions class="mx-0 pa-0">
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="onCancel">Cancel</v-btn>
      <v-btn color="primary" text @click="processAdd">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CreateOne789',
  props: ['onCreated', 'onCancel'],
  data: () => ({
    item: {}
  }),
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
      createItem: 'one_789/create'
    }),
    processAdd() {
      this.createItem(this.item).then(() => {
        this.onCreated();
        this.item = {};
      });
    }
  }
}
</script>
